import {
  GET_LABREQUESTQUOTE,
  GET_LABREQUESTQUOTE_FAIL,
  GET_LABREQUESTQUOTE_SUCCESS,
  GET_LABREQUESTQUOTES,
  GET_LABREQUESTQUOTES_FAIL,
  GET_LABREQUESTQUOTES_SUCCESS,
  ADD_NEW_LABREQUESTQUOTE,
  ADD_LABREQUESTQUOTE_SUCCESS,
  ADD_LABREQUESTQUOTE_FAIL,
  UPDATE_LABREQUESTQUOTE,
  UPDATE_LABREQUESTQUOTE_SUCCESS,
  UPDATE_LABREQUESTQUOTE_FAIL,
  DELETE_LABREQUESTQUOTE,
  DELETE_LABREQUESTQUOTE_SUCCESS,
  DELETE_LABREQUESTQUOTE_FAIL,
  SET_STATE_LABREQUESTQUOTE,
  UPDATE_LABREQUESTQUOTE_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTQUOTE,
  payload: loading,
})

export const getLabRequestQuotes = ( params ) => ({
  type: GET_LABREQUESTQUOTES,
  payload: { params },
})

export const getLabRequestQuotesSuccess = (labRequestQuotes, totalPages, currentPage) => ({
  type: GET_LABREQUESTQUOTES_SUCCESS,
  payload: { labRequestQuotes:labRequestQuotes, total:totalPages, currentPage:currentPage}
})

export const getLabRequestQuotesFail = error => ({
  type: GET_LABREQUESTQUOTES_FAIL,
  payload: error,
})

export const addNewLabRequestQuote = labRequestQuote => ({
  type: ADD_NEW_LABREQUESTQUOTE,
  payload: labRequestQuote,
})

export const addLabRequestQuoteSuccess = labRequestQuote => ({
  type: ADD_LABREQUESTQUOTE_SUCCESS,
  payload: labRequestQuote,
})  

export const addLabRequestQuoteFail = error => ({
  type: ADD_LABREQUESTQUOTE_FAIL,
  payload: error,
})

export const updateLabRequestQuote = labRequestQuote => ({
  type: UPDATE_LABREQUESTQUOTE,
  payload: labRequestQuote,
})

export const updateLabRequestQuoteStatus = labRequestQuote => ({
  type: UPDATE_LABREQUESTQUOTE_STATUS,
  payload: labRequestQuote,
})

export const updateLabRequestQuoteSuccess = labRequestQuote => ({
  type: UPDATE_LABREQUESTQUOTE_SUCCESS,
  payload: labRequestQuote,
})

export const updateLabRequestQuoteFail = error => ({
  type: UPDATE_LABREQUESTQUOTE_FAIL,
  payload: error,
})

export const deleteLabRequestQuote = labRequestQuote => ({
  type: DELETE_LABREQUESTQUOTE,
  payload: labRequestQuote,
})

export const deleteLabRequestQuoteSuccess = id => ({
  type: DELETE_LABREQUESTQUOTE_SUCCESS,
  id,
})

export const deleteLabRequestQuoteFail = error => ({
  type: DELETE_LABREQUESTQUOTE_FAIL,
  payload: error,
})

export const getLabRequestQuote = () => ({
  type: GET_LABREQUESTQUOTE,
})

export const getLabRequestQuoteSuccess = labRequestQuote => ({
  type: GET_LABREQUESTQUOTE_SUCCESS,
  payload: labRequestQuote,
})

export const getLabRequestQuoteFail = error => ({
  type: GET_LABREQUESTQUOTE_FAIL,
  payload: error,
})
